module.exports = __webpack_public_path__ + "img/bg-business-cooperation.33344322.png";